module.exports = __webpack_public_path__ + "media/images/diy/wedding_monogram_name_light-6a6f6c2a17d19da1cd76a93ab3f93499.jpg";